import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { TabsModule } from 'primeng/tabs';
import { InputTextModule } from 'primeng/inputtext';
import { GeneralInfoComponent } from './components/general-info/general-info.component';
import { ContactInfoComponent } from './components/contact-info/contact-info.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { UpdateUserDto, UserRole } from '../../interfaces';
import { SpinnerComponent } from '../../partial-components';
import { UserHttpService, UserService } from '../../services';
import { TranslationService } from '../../services/translation.service';
import { TranslatePipe } from '@ngx-translate/core';

type Tabs = 'Contact' | 'General' | 'User';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent,
    TabsModule,
    InputTextModule,
    GeneralInfoComponent,
    ContactInfoComponent,
    EditUserComponent,
    TranslatePipe
  ],
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('formError') formErrorTemplate!: TemplateRef<any>;
  @ViewChild('confirmationModal') confirmationModal!: TemplateRef<any>;

  translateService = inject(TranslationService);
  users: UpdateUserDto[] = [];

  user: any;
  activeTab: Tabs = 'Contact';

  showChangePasswordForm: boolean = false;
  isLoading!: boolean;

  loadingData: boolean = true;

  hasError: boolean = false;
  confirmationModalVisible = false;

  subscriptions: Subscription[] = [];

  roles$: Observable<UserRole[]> = new Observable();

  tabValue: number = 0;

  public userService = inject(UserHttpService);
  private route = inject(ActivatedRoute);
  constructor() {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const userId = params['id'];
      const userSubscription$ = this.userService.getUserById(userId);
      const subscriptions$ = forkJoin([userSubscription$]).subscribe({
        next: ([userResult]) => {
          this.user = userResult;
          this.loadingData = false;
          this.roles$ = this.userService.getUserRoles();
        },
      });
      this.subscriptions.push(subscriptions$);
    });
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      this.subscriptions.pop();
    });
  }

  static MatchPassword2(control: AbstractControl): void {
    const newPassword = control.get('newPassword')?.value;
    const confirmNewPassword = control.get('confirmNewPassword')?.value;

    if (newPassword !== confirmNewPassword) {
      control
        .get('confirmNewPassword')
        ?.setErrors({ confirmNewPassword: true });
    }
  }

  setActiveTab(tab: Tabs) {
    this.activeTab = tab;
  }

  togglePasswordForm(show: boolean) {
    this.showChangePasswordForm = show;
  }

  savePassword() {
    setTimeout(() => {
      this.showChangePasswordForm = false;
      this.loadingData = false;
    }, 1500);
  }

  get formError(): TemplateRef<any> {
    return this.formErrorTemplate;
  }
}
